
// FAQ collapsible color change - Rise theme (titles, caret, and row content)
document.addEventListener('DOMContentLoaded', function () {
  const faqAccordions = document.querySelectorAll('body.gradient .collapsible-content .accordion details');

  faqAccordions.forEach(details => {
    const summary = details.querySelector('summary');
    const title = summary.querySelector('.accordion__title');
    const svg = summary.querySelector('svg');
    const content = details.querySelector('.accordion__content.rte');

    // Set initial colors and opacity
    if (details.hasAttribute('open')) {
      title.style.color = '#004225';
      if (svg) svg.style.stroke = svg.style.fill = '#004225';
      if (content) content.style.color = '#000';
      if (content) content.style.opacity = '1';
    } else {
      title.style.color = '#000000';
      if (svg) svg.style.stroke = svg.style.fill = '#000000';
      if (content) content.style.color = '#000';
      if (content) content.style.opacity = '0.6';
    }

    // Add toggle listener
    summary.addEventListener('click', () => {
      setTimeout(() => {
        if (details.hasAttribute('open')) {
          title.style.color = '#004225';
          if (svg) svg.style.stroke = svg.style.fill = '#004225';
          if (content) content.style.color = '#000';
          if (content) content.style.opacity = '1';
        } else {
          title.style.color = '#000000';
          if (svg) svg.style.stroke = svg.style.fill = '#000000';
          if (content) content.style.color = '#000';
          if (content) content.style.opacity = '0.6';
        }
      }, 0);
    });
  });
});

// FAQ collapsible staggered animation - Rise theme
document.addEventListener('DOMContentLoaded', function () {
  const rows = document.querySelectorAll('body.gradient .collapsible-content__grid-item');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  rows.forEach((row, index) => {
    row.style.transitionDelay = `${index * 0.1}s`;
    observer.observe(row);
  });
});
